module.exports = __webpack_public_path__ + "img/icons B_30.9be2d5ea.svg";